<template>
  <div class="app-download-page">
    <div class="nav-header">
      <NavHeader
        :status="{
          page: 'download',
          produce: false,
          solution: false,
        }"
      />
    </div>

    <div class="download-hero">
      <div class="hero-content">
        <div class="hero-left">
          <h1 class="hero-title">蜥翼实验室</h1>
          <div class="hero-card">
            <p class="hero-desc">专为中小学生设计的AI虚拟仿真实验学习平台，覆盖小学科学，初中物理、化学、生物三大学科</p>
            <div class="hero-buttons">
              <div class="hero-btn hero-btn-android" @click="downloadAndroid">
                <div class="hero-btn-icon android-icon-sm"></div>
                <div class="hero-btn-text">
                  <div class="hero-btn-label">Android 下载</div>
                  <div class="hero-btn-sub">安卓手机</div>
                </div>
              </div>
              <div class="hero-btn hero-btn-ios" @click="downloadIOS">
                <div class="hero-btn-icon ios-icon-sm"></div>
                <div class="hero-btn-text">
                  <div class="hero-btn-label">iOS 下载</div>
                  <div class="hero-btn-sub">TestFlight</div>
                </div>
              </div>
            </div>
            <p class="hero-agreement">下载即代表您同意 <a href="/lab/user-agreement.html" target="_blank">用户协议</a> 和 <a href="/lab/privacy-policy.html" target="_blank">隐私政策</a></p>
          </div>
        </div>
        <div class="hero-phone"></div>
      </div>
    </div>

    <div class="about-section">
      <div class="section-title">产品介绍</div>
      <div class="section-subtitle">教材同步 + 动手实验 + AI伴学</div>
      <div class="about-content">
        <div class="about-text">
          <p>蜥翼实验室是一款专为中小学生设计的AI虚拟仿真实验学习平台，覆盖<strong>小学科学，初中物理、化学、生物</strong>三大学科。</p>
          <p>平台以"教材同步 + 动手实验 + AI伴学"为核心，提供<strong>教材同步、闯关答题、模拟训练</strong>三大学习模块，帮助学生安全、高效地掌握实验知识与操作技能。</p>
          <p>无论课堂学习还是课后复习，蜥翼实验室都能提供沉浸式、交互式的实验体验，让学生在虚拟环境中动手操作，理解科学原理，提升实验素养。</p>
        </div>
      </div>
    </div>

    <div class="features-section">
      <div class="section-title">核心功能</div>
      <div class="section-subtitle">多维度学习，全方位提升</div>
      <div class="features-grid">
        <div class="feature-card">
          <div class="feature-card-icon icon-textbook"></div>
          <div class="feature-card-title">教材同步</div>
          <div class="feature-card-desc">按教材版本、年级、章节筛选实验，匹配课堂进度</div>
        </div>
        <div class="feature-card">
          <div class="feature-card-icon icon-challenge"></div>
          <div class="feature-card-title">闯关答题</div>
          <div class="feature-card-desc">分学科分模块闯关，看做学练巩固知识</div>
        </div>
        <div class="feature-card">
          <div class="feature-card-icon icon-simulate"></div>
          <div class="feature-card-title">模拟训练</div>
          <div class="feature-card-desc">自主实验，步骤指引，精准评分</div>
        </div>
        <div class="feature-card">
          <div class="feature-card-icon icon-exam"></div>
          <div class="feature-card-title">中考专区</div>
          <div class="feature-card-desc">按地区/年份筛选真题，直击中考考点</div>
        </div>
        <div class="feature-card">
          <div class="feature-card-icon icon-island"></div>
          <div class="feature-card-title">科学岛</div>
          <div class="feature-card-desc">沉浸式游戏化探索，趣味闯关积攒知识卡</div>
        </div>
        <div class="feature-card">
          <div class="feature-card-icon icon-ai"></div>
          <div class="feature-card-title">AI助手</div>
          <div class="feature-card-desc">智能问答助手，实时解答实验疑问</div>
        </div>
      </div>
    </div>

    <div class="subjects-section">
      <div class="section-title">学科覆盖</div>
      <div class="section-subtitle">全学科实验内容，满足不同学段需求</div>
      <div class="subjects-grid">
        <div class="subject-card subject-physics">
          <div class="subject-icon"></div>
          <div class="subject-name">初中物理</div>
          <div class="subject-desc">电热声光磁全覆盖</div>
        </div>
        <div class="subject-card subject-chemistry">
          <div class="subject-icon"></div>
          <div class="subject-name">初中化学</div>
          <div class="subject-desc">高仿真化学实验场景</div>
        </div>
        <div class="subject-card subject-biology">
          <div class="subject-icon"></div>
          <div class="subject-name">初中生物</div>
          <div class="subject-desc">直观展示微观与长周期现象</div>
        </div>
        <div class="subject-card subject-science">
          <div class="subject-icon"></div>
          <div class="subject-name">小学科学</div>
          <div class="subject-desc">科学启蒙，趣味实验</div>
        </div>
      </div>
    </div>

    <div class="vip-section">
      <div class="section-title">会员权益</div>
      <div class="section-subtitle">解锁更多优质实验内容</div>
      <div class="vip-grid">
        <div class="vip-item">
          <div class="vip-check"></div>
          <span>全部实验解锁</span>
        </div>
        <div class="vip-item">
          <div class="vip-check"></div>
          <span>模拟训练全开放</span>
        </div>
        <div class="vip-item">
          <div class="vip-check"></div>
          <span>中考专区全开放</span>
        </div>
        <div class="vip-item">
          <div class="vip-check"></div>
          <span>全部实验视频</span>
        </div>
        <div class="vip-item">
          <div class="vip-check"></div>
          <span>AI助手全开放</span>
        </div>
        <div class="vip-item">
          <div class="vip-check"></div>
          <span>每日双倍积分</span>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import NavHeader from "@/components/NavHeader";
export default {
  name: "app-download",
  components: {
    Footer,
    NavHeader,
  },
  methods: {
     downloadAndroid() {
      window.location.href = 'https://app.lab.ekwclass.com/download/mobile/'
     },
     downloadIOS() {
      window.location.href = 'https://testflight.apple.com/join/hAHP2v2a'
     }
  }
};
</script>

<style scoped>
.app-download-page {
  width: 100vw;
  overflow-x: hidden;
  background-color: #f9faff;
}
.nav-header {
  width: 100vw;
  height: 4vw;
}

.download-hero {
  width: 100vw;
  height: 48vw;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 40%, #0f3460 100%);
  position: relative;
  overflow: hidden;
}
.hero-content {
  width: 80vw;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  position: relative;
  z-index: 2;
}
.hero-left {
  width: 45vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.hero-title {
  font-family: test;
  font-size: 3.5vw;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 3px;
  margin-bottom: 2vw;
}
.hero-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 1.2vw;
  padding: 2.5vw 3vw;
  backdrop-filter: blur(10px);
}
.hero-desc {
  font-family: test;
  font-size: 1vw;
  color: rgba(255, 255, 255, 0.75);
  letter-spacing: 0.5px;
  line-height: 2vw;
  margin-bottom: 2vw;
}
.hero-buttons {
  display: flex;
  flex-direction: row;
  gap: 1.5vw;
  margin-bottom: 1.5vw;
}
.hero-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.8vw 1.8vw;
  border-radius: 0.8vw;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 14vw;
}
.hero-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}
.hero-btn-android {
  background-color: #3ddc84;
  color: #fff;
}
.hero-btn-android:hover {
  background-color: #2ec974;
}
.hero-btn-ios {
  background-color: #007aff;
  color: #fff;
}
.hero-btn-ios:hover {
  background-color: #006ae0;
}
.hero-btn-icon {
  width: 2.2vw;
  height: 2.2vw;
  margin-right: 1vw;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  flex-shrink: 0;
}
.android-icon-sm {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M17.523 2.273l1.732-2.998a.5.5 0 00-.866-.5l-1.75 3.03A10.426 10.426 0 0012 .977a10.43 10.43 0 00-4.64 1.828L5.61-.227a.5.5 0 00-.866.5l1.732 3C3.374 5.477 1.5 8.416 1.5 11.77h23c0-3.354-1.874-6.293-4.977-9.497zM7.5 8.77a1 1 0 110-2 1 1 0 010 2zm9 0a1 1 0 110-2 1 1 0 010 2zM1.5 12.77c0-.55.45-1 1-1h22c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1h-22c-.55 0-1-.45-1-1v-9z'/%3E%3C/svg%3E");
}
.ios-icon-sm {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.93 1.42-.15-1.15.41-2.35 1.03-3.11z'/%3E%3C/svg%3E");
}
.hero-btn-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.hero-btn-label {
  font-family: test;
  font-size: 1.1vw;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 1.4;
}
.hero-btn-sub {
  font-family: test;
  font-size: 0.7vw;
  opacity: 0.85;
  letter-spacing: 0.5px;
  line-height: 1.4;
}
.hero-agreement {
  font-family: test;
  font-size: 0.7vw;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 0.5px;
  line-height: 1.5;
}
.hero-agreement a {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: underline;
  transition: color 0.2s;
}
.hero-agreement a:hover {
  color: rgba(255, 255, 255, 0.9);
}
.hero-phone {
  width: 38vw;
  height: 35vw;
  margin-top: 4vw;
  background-image: url("http://data.xiyilab.com/web/main/static/资源下载/iPhones.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.about-section {
  width: 80vw;
  margin: 0 auto;
  padding: 5vw 0 2vw;
}
.section-title {
  font-family: test;
  font-size: 2vw;
  font-weight: 700;
  color: #3e3a39;
  text-align: center;
  margin-bottom: 0.5vw;
}
.section-subtitle {
  font-family: test;
  font-size: 0.9vw;
  color: #999;
  text-align: center;
  margin-bottom: 3vw;
  letter-spacing: 1px;
}
.about-content {
  background: #fff;
  border-radius: 1vw;
  padding: 3vw 4vw;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}
.about-text p {
  font-family: test;
  font-size: 1vw;
  color: #555;
  line-height: 2.2vw;
  margin-bottom: 1.5vw;
  letter-spacing: 0.5px;
}
.about-text p:last-child {
  margin-bottom: 0;
}
.about-text strong {
  color: #3e3a39;
}

.features-section {
  width: 80vw;
  margin: 0 auto;
  padding: 4vw 0 2vw;
}
.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5vw;
  margin-top: 2vw;
}
.feature-card {
  background: #fff;
  border-radius: 1vw;
  padding: 2vw 1.5vw;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}
.feature-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}
.feature-card-icon {
  width: 3.5vw;
  height: 3.5vw;
  margin: 0 auto 1vw;
  border-radius: 0.8vw;
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center;
}
.icon-textbook {
  background-color: #e8f4fd;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%232196F3'%3E%3Cpath d='M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z'/%3E%3C/svg%3E");
}
.icon-challenge {
  background-color: #fff3e0;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FF9800'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'/%3E%3C/svg%3E");
}
.icon-simulate {
  background-color: #e8f5e9;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%234CAF50'%3E%3Cpath d='M7 2v11h3v9l7-12h-4l4-8z'/%3E%3C/svg%3E");
}
.icon-exam {
  background-color: #fce4ec;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23E91E63'%3E%3Cpath d='M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z'/%3E%3C/svg%3E");
}
.icon-island {
  background-color: #e0f7fa;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2300BCD4'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5.5-2.5l7.51-3.49L17.5 6.5 9.99 9.99 6.5 17.5zm5.5-6.5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z'/%3E%3C/svg%3E");
}
.icon-ai {
  background-color: #ede7f6;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23673AB7'%3E%3Cpath d='M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-8 11H7v-2h5v2zm5-4H7V7h10v2z'/%3E%3C/svg%3E");
}
.feature-card-title {
  font-family: test;
  font-size: 1.1vw;
  font-weight: 700;
  color: #3e3a39;
  margin-bottom: 0.5vw;
}
.feature-card-desc {
  font-family: test;
  font-size: 0.8vw;
  color: #888;
  letter-spacing: 0.5px;
}

.subjects-section {
  width: 80vw;
  margin: 0 auto;
  padding: 4vw 0 2vw;
}
.subjects-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5vw;
  margin-top: 2vw;
}
.subject-card {
  background: #fff;
  border-radius: 1vw;
  padding: 2.5vw 1vw;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.subject-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}
.subject-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 0.3vw;
}
.subject-physics::before { background: linear-gradient(90deg, #5eb2f7, #3a8fd8); }
.subject-chemistry::before { background: linear-gradient(90deg, #a4a047, #8b8735); }
.subject-biology::before { background: linear-gradient(90deg, #76d187, #56b868); }
.subject-science::before { background: linear-gradient(90deg, #ff9f43, #ee8a2e); }
.subject-icon {
  width: 4vw;
  height: 4vw;
  margin: 0 auto 1vw;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.subject-physics .subject-icon {
  background-image: url("http://data.xiyilab.com/web/main/static/首页/物理实验1.png");
}
.subject-chemistry .subject-icon {
  background-image: url("http://data.xiyilab.com/web/main/static/首页/化学实验1.png");
}
.subject-biology .subject-icon {
  background-image: url("http://data.xiyilab.com/web/main/static/首页/生物实验1.png");
}
.subject-science .subject-icon {
  background-color: #fff3e0;
  border-radius: 50%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FF9800'%3E%3Cpath d='M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z'/%3E%3C/svg%3E");
  background-size: 50%;
}
.subject-name {
  font-family: test;
  font-size: 1.1vw;
  font-weight: 700;
  color: #3e3a39;
  margin-bottom: 0.4vw;
}
.subject-desc {
  font-family: test;
  font-size: 0.8vw;
  color: #999;
}

.vip-section {
  width: 80vw;
  margin: 0 auto;
  padding: 4vw 0 2vw;
}
.vip-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5vw;
  margin-top: 2vw;
}
.vip-item {
  background: #fff;
  border-radius: 0.6vw;
  padding: 1.2vw 1.5vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}
.vip-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}
.vip-check {
  width: 1.4vw;
  height: 1.4vw;
  margin-right: 1vw;
  flex-shrink: 0;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%233ddc84'%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.vip-item span {
  font-family: test;
  font-size: 0.95vw;
  color: #555;
}
</style>
}
</style>